<template>
    <b-form @keyup.enter="save" @submit.prevent>
        <p class='text-center mb-4'>
            {{$t('pages.selfservice.passwordReset.userQuery')}}
        </p>
        <b-form-group>
            <fr-floating-label-input v-model="mail" fieldName="mail" :label="$t('common.placeholders.emailAddress')" type="text" autofocus="true"></fr-floating-label-input>
        </b-form-group>

        <b-button @click="save" size="lg" :block="true" variant="primary">
            <div v-if="apiType === 'username'">
                {{$t("pages.selfservice.forgotUsername.advanceStageButtonText")}}
            </div>
            <div v-else>
                {{$t("pages.selfservice.passwordReset.advanceStageButtonText")}}
            </div>
        </b-button>
    </b-form>
</template>

<script>
import FloatingLabelInput from '@/components/utils/FloatingLabelInput';

/**
 * @description Selfservice stage for multiple selfservice flows, typically used with an email to locate a user in the system to continue on with further
 * selfservice stages
 *
 **/
export default {
    name: 'User-Query',
    components: {
        'fr-floating-label-input': FloatingLabelInput
    },
    props: {
        apiType: { required: true }
    },
    data () {
        return {
            mail: ''
        };
    },
    methods: {
        getData () {
            return {
                queryFilter: `mail eq "${this.mail}"`
            };
        },
        save () {
            /* istanbul ignore next */
            let mailFilter = 'mail+eq+"' + this.mail + '"', userType = '';
            this.getRequestService().get('managed/user?_queryFilter=' + mailFilter, { headers: this.getAnonymousHeaders() }).then((response) => {
                userType = response.data.result[0].userType.toLowerCase();
                if (userType === 'interno') {
                    this.displayNotification('error', 'Operazione non permessa per i dipendenti del dipartimento');
                } else if (userType === 'spid') {
                    this.displayNotification('error', 'Operazione non permessa per gli utenti SPID. Reset Password da effettuare tramite il proprio Identity Provider');
                } else {
                    this.$emit('advanceStage', this.getData());
                }
            });
        }
    }
};
</script>
